/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Teen_Confirm_ActionInputs */

const fr_household_teen_confirm_action = /** @type {(inputs: Household_Teen_Confirm_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désinscrire tout le monde`)
};

/**

* @param {Household_Teen_Confirm_ActionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_teen_confirm_action = /** @type {((inputs?: Household_Teen_Confirm_ActionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Teen_Confirm_ActionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_teen_confirm_action(inputs)
});